import { faEuro, faGbp, faUsd } from '@fortawesome/pro-solid-svg-icons';

import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal, Vertical } from 'atoms/layout/flex';
import { LabelM, LabelXS } from 'atoms/typography';
import { Dots } from 'atoms/ui/Dots';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useIntlContext } from 'contexts/intl';
import { useFiatBalance } from 'hooks/wallets/useFiatBalance';

type Props = { collapsed?: boolean };
export const FiatBalance = ({ collapsed }: Props) => {
  const { formatNumber } = useIntlContext();
  const { currentUser, fiatCurrency } = useCurrentUserContext();
  const { availableBalanceWithCurrencySymbol, availableBalance } =
    useFiatBalance({
      notation: 'compact',
      compactDisplay: 'short',
    });

  const currencyIcon = {
    EUR: faEuro,
    GBP: faGbp,
    USD: faUsd,
  }[fiatCurrency.code];

  const hideBalance = currentUser?.userSettings?.hideBalance;

  if (collapsed) {
    return (
      <Vertical gap={0.5} center>
        <FontAwesomeIcon icon={currencyIcon} size="1x" />
        <LabelXS bold>
          {formatNumber(availableBalance, {
            currency: fiatCurrency.code,
            notation: 'compact',
            compactDisplay: 'short',
          })}
        </LabelXS>
      </Vertical>
    );
  }

  return hideBalance ? (
    <Horizontal center>
      <FontAwesomeIcon icon={faEuro} />
      <Horizontal gap={0.5}>
        <Dots count={3} size="small" />
      </Horizontal>
    </Horizontal>
  ) : (
    <LabelM bold>{availableBalanceWithCurrencySymbol}</LabelM>
  );
};
